<template>
	<div class="row">
		<div class="col-lg-12">
			<div class="box">
				<div class="box-body clearfix">
					<form class="form-inline col-sm-12 col-lg-9" role="form">
						<div class="form-group">
							<input-select
								:options="computedTankGroups"
								name="tank_group_id"
								:vmodel.sync="selectedTankGroup"
								label="Tank Group:"
								value="favourites"
								:inline="true">
							</input-select>
						</div>
						<div class="form-group">
							<label for="search">Search:</label>
							<input name="search" v-model="search" class="form-control">
						</div>
						<div class="form-group" v-show="$route.name == 'dashboard'">
							<div class="checkbox">
								<label>
									<input type="checkbox" v-model="showEmpty"> Hide empty fermenters
								</label>
							</div>
						</div>
						<div class="form-group" v-show="$route.name == 'dashboard'">
							<div class="checkbox">
								<label>
									<input type="checkbox" v-model="showOutOfSpec"> Show out-of-spec only
								</label>
							</div>
						</div>
						<div class="form-group" v-show="$route.name == 'dashboard.bulk-entry'">
							<input-date label="Date:" name="start_date" :vmodel.sync="date" :inline="true" date-format="DD/MM/YYYY"></input-date>
						</div>
						<div class="form-group" v-show="$route.name == 'dashboard.bulk-entry'">
							<input-toggle
								name="period"
								:vmodel.sync="period"
								on="PM"
								off="AM"
								off-style="primary">
							</input-toggle>
						</div>
					</form>
					<div class="col-sm-12 col-lg-3">
						<div class="form-group text-right">
							<a v-if="$route.name != 'dashboard.bulk-entry'" class="btn btn-xs btn-success"
								:href="Http.buildPath(`fermenters-download/${site.id}`)"
								v-bind:class="{ 'disabled': eventLoading }">
								<!-- @click.prevent="exportFermenters(this.site.id, this.defaultInclude)" href="#"> -->
								Export
							</a>

							<a v-if="$route.name != 'dashboard.bulk-entry'" class="btn btn-xs btn-success" @click.prevent="$router.go({ name: 'dashboard.bulk-entry' })" href="#">Bulk Data Entry</a>
							<a v-else class="btn btn-xs btn-success" @click.prevent="$router.go({ name: 'dashboard' })" href="#">Back To Dashboard</a>

							<a style="margin-left: 15px;" class="fa fa-lg fa-question-circle popover-help" href="#" data-toggle="modal" data-target="#dashboard_help_modal"></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Http from 'utils/http'

	export default {
		data() {
			return {
				Http
			};
		},

		props: [
			'computedTankGroups', 'selectedTankGroup', 'showEmpty', 'showOutOfSpec', 'eventLoading',
			'date', 'search', 'period', 'defaultInclude', 'exportFermenters', 'site'
		]
	}
</script>



// WEBPACK FOOTER //
// filters.vue?273435e3